<template>
  <v-container fluid id="NewWorkOrder">
    <!-- submitted dialog -->
    <v-dialog v-model="submitted" persistent width="500">
      <v-card>
        <v-card-text v-if="submitting">
          <h2 class="title mb-4 pt-4">Submitting Truck Request...</h2>
          <v-progress-linear
            indeterminate
            class="mb-0 mt-4"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-else class="text-center">
          <h2 class="title mb-4 pt-4">Truck Request successfully submitted!</h2>
          <v-btn color="primary" outlined to="/truck-requests/orders"
            ><v-icon left>chevron_left</v-icon> Back to My Truck Requests</v-btn
          >
          <div>
            <v-btn text @click="submitted = false" class="mt-4">close</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row wrap>
      <v-col cols="12" class="headline pl-0">
        <v-btn
          color="primary"
          class="mr-2 pa-0"
          small
          outlined
          text
          :to="
            editMode
              ? '/truck-requests/manage/orders'
              : '/truck-requests/orders'
          "
          style="margin-top:-3px"
          ><v-icon>chevron_left</v-icon></v-btn
        >
        {{ editMode ? "Edit" : "New" }} Truck Request
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col cols="12" sm="12" md="6" class="px-0">
        <v-skeleton-loader type="card"></v-skeleton-loader>
      </v-col>
    </v-row>

    <!-- JOB DETAILS -->
    <v-form v-model="valid" ref="form" lazy-validation v-else>
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row class="mb-0">
                  <v-col
                    xs="12"
                    class="pb-0"
                    v-if="
                      user.role === 'Truck Manager' ||
                        editMode ||
                        (user.permissionGroups || []).includes(
                          'externalTruckRequests'
                        )
                    "
                  >
                    <job-selector-all
                      @jobSiteChange="jobSite = $event"
                      :jobDocId="jobDocId"
                    />
                  </v-col>
                  <v-col xs="12" class="pb-0" v-else>
                    <job-selector @jobSiteChange="jobSite = $event" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12">
                    <v-select
                      :items="['Packer', 'Roll Off', 'Mini Pickup/Dropoff']"
                      v-model="requestType"
                      @change="requestTypeChange"
                      label="Type"
                      prepend-icon="delete_sweep"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-select
                      :items="requestDays"
                      v-model="requestDate"
                      label="Request Date(s)"
                      item-value="requestDate"
                      item-text="displayDate"
                      prepend-icon="event"
                      required
                      :rules="[(v) => !!v.length || 'Date is required']"
                      :multiple="!editMode"
                      :hint="
                        !editMode && requestDate.length > 1
                          ? 'A duplicate Truck Request will be created for each date selected.'
                          : ''
                      "
                      persistent-hint
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-select
                      :items="[
                        '12:15am',
                        '12:30am',
                        '12:45am',
                        '1:00am',
                        '1:15am',
                        '1:30am',
                        '1:45am',
                        '2:00am',
                        '2:15am',
                        '2:30am',
                        '2:45am',
                        '3:00am',
                        '3:15am',
                        '3:30am',
                        '3:45am',
                        '4:00am',
                        '4:15am',
                        '4:30am',
                        '4:45am',
                        '5:00am',
                        '5:15am',
                        '5:30am',
                        '5:45am',
                        '6:00am',
                        '6:15am',
                        '6:30am',
                        '6:45am',
                        '7:00am',
                        '7:15am',
                        '7:30am',
                        '7:45am',
                        '8:00am',
                        '8:15am',
                        '8:30am',
                        '8:45am',
                        '9:00am',
                        '9:15am',
                        '9:30am',
                        '9:45am',
                        '10:00am',
                        '10:15am',
                        '10:30am',
                        '10:45am',
                        '11:00am',
                        '11:15am',
                        '11:30am',
                        '11:45am',
                        '12:00pm',
                        '12:15pm',
                        '12:30pm',
                        '12:45pm',
                        '1:00pm',
                        '1:15pm',
                        '1:30pm',
                        '1:45pm',
                        '2:00pm',
                        '2:15pm',
                        '2:30pm',
                        '2:45pm',
                        '3:00pm',
                        '3:15pm',
                        '3:30pm',
                        '3:45pm',
                        '4:00pm',
                        '4:15pm',
                        '4:30pm',
                        '4:45pm',
                        '5:00pm',
                        '5:15pm',
                        '5:30pm',
                        '5:45pm',
                        '6:00pm',
                        '6:15pm',
                        '6:30pm',
                        '6:45pm',
                        '7:00pm',
                        '7:15pm',
                        '7:30pm',
                        '7:45pm',
                        '8:00pm',
                        '8:15pm',
                        '8:30pm',
                        '8:45pm',
                        '9:00pm',
                        '9:15pm',
                        '9:30pm',
                        '9:45pm',
                        '10:00pm',
                      ]"
                      v-model="requestTime"
                      prepend-icon="schedule"
                      label="Request Time"
                      return-object
                      hide-details
                      required
                      :rules="[(v) => !!v || 'Request Time is required']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-select
                      :items="[1, 2, 3]"
                      v-model.number="numberOfTrucks"
                      label="How many trucks?"
                      prepend-icon="format_list_numbered"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-select
                      hide-details
                      prepend-icon="timelapse"
                      label="Duration"
                      v-model="duration"
                      :items="[
                        '15 Minutes',
                        '30 Minutes',
                        '45 Minutes',
                        '1 Hour',
                        '1 Hour & 15 Minutes',
                        '1 Hour & 30 Minutes',
                        '1 Hour & 45 Minutes',
                        '2 Hours',
                        '2 Hour & 15 Minutes',
                        '2 Hour & 30 Minutes',
                        '2 Hour & 45 Minutes',
                        '3 Hours',
                        '3 Hour & 15 Minutes',
                        '3 Hour & 30 Minutes',
                        '3 Hour & 45 Minutes',
                        '4 Hours',
                        '4 Hour & 15 Minutes',
                        '4 Hour & 30 Minutes',
                        '4 Hour & 45 Minutes',
                        '5 Hours',
                        '5 Hour & 15 Minutes',
                        '5 Hour & 30 Minutes',
                        '5 Hour & 45 Minutes',
                        '6 Hours',
                        '6 Hour & 15 Minutes',
                        '6 Hour & 30 Minutes',
                        '6 Hour & 45 Minutes',
                        'All Afternoon',
                        'All Day',
                      ]"
                      type="text"
                      required
                      :rules="[(v) => !!v || 'duration Type is required']"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="requestType && jobSite">
        <v-col
          cols="12"
          sm="12"
          md="6"
          class="px-0"
          v-if="['Roll Off', 'Packer'].includes(requestType)"
        >
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-col xs="4">
                  <v-select
                    :items="pickupTypeOptions"
                    v-model="pickupType"
                    label="Pickup Type"
                    required
                    :rules="[(v) => !!v || 'Pickup Type is required']"
                  ></v-select>
                </v-col>
                <v-col
                  xs="4"
                  v-if="pickupType == 'Live Load' && requestType == 'Roll Off'"
                >
                  <v-select
                    :items="[
                      '1 Hour',
                      '2 Hour',
                      '3 Hour',
                      '4 Hour',
                      '5 Hour',
                      '6 Hour',
                      '7 Hour',
                      '8 Hour',
                    ]"
                    v-model="waitTime"
                    label="Wait Time (Live Load)"
                    required
                    :rules="[(v) => !!v || 'Wait time is required']"
                  ></v-select>
                </v-col>
                <v-col xs="4">
                  <v-select
                    :items="[
                      'C&D',
                      'Brick',
                      'Concrete',
                      'Wood',
                      'Dirt',
                      'Metal',
                      'Sheetrock',
                      'Plaster',
                      'Gypsum',
                      'Cardboard',
                      'Terracotta',
                      'Plastic',
                      'Roofing',
                      'Aluminum',
                      'Other',
                    ]"
                    v-model="materialType"
                    required
                    :rules="[
                      (v) =>
                        !!v.length || 'Must choose at least one material type',
                    ]"
                    multiple
                    chips
                    deletable-chips
                    label="Material"
                  ></v-select>
                </v-col>
                <v-col xs="2" v-if="requestType == 'Roll Off'">
                  <v-select
                    :items="[10, 20, 30, 40]"
                    v-model="qty"
                    label="Container Size (Yrds)"
                    required
                    :rules="[(v) => !!v || 'Container size is required']"
                  ></v-select>
                </v-col>
                <v-col xs="2" v-if="requestType == 'Packer'">
                  <v-select
                    v-if="pickupType == 'Loose Yards'"
                    :disabled="fullLoad"
                    :rules="[(v) => !!v || 'Yards is required']"
                    :items="[
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                    ]"
                    v-model="qty"
                    label="Yards"
                  ></v-select>
                  <v-text-field
                    v-if="pickupType == 'Garbage Cans'"
                    type="number"
                    label="Number of Garbage Cans"
                    v-model="qty"
                  ></v-text-field>
                  <v-text-field
                    v-if="pickupType == 'Mini Containers'"
                    type="number"
                    label="Number of Mini Containers"
                    v-model="qty"
                  >
                  </v-text-field>
                  <v-checkbox
                    color="primary"
                    label="Full Load"
                    v-model="fullLoad"
                    @change="updateLooseYards"
                  ></v-checkbox>
                  <v-select
                    :items="[1, 2, 3, 4, 5, 6]"
                    v-if="fullLoad"
                    v-model.number="fullLoadsQty"
                    label="How many full loads?"
                    @change="updateLooseYards"
                    hide-details
                  ></v-select>
                </v-col>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          class="px-0"
          v-if="requestType == 'Mini Pickup/Dropoff'"
        >
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-col class="font-weight-bold" cols="12" xs="4">
                  Set the number of Mini containers you want picked up or
                  dropped off.
                </v-col>
                <v-col cols="12" xs="4">
                  <v-text-field
                    v-model.number="miniDropoffQty"
                    value="0"
                    type="number"
                    label="Mini Dropoff"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="4">
                  <v-text-field
                    v-model.number="miniPickupQty"
                    :value="13"
                    :rules="[
                      (v) =>
                        v <= miniCount ||
                        'You cannot return more than you have.',
                    ]"
                    type="number"
                    label="Mini Pickup"
                  ></v-text-field>
                  <div class="red--text font-weight-bold mt-3">
                    * You have {{ miniCount }} Mini's on site.
                  </div>
                  <div>
                    If this number is not correct please contact Mike Perugini
                    ASAP.
                  </div>
                </v-col>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="requestType && jobSite">
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-col>
                  <v-textarea
                    outlined
                    label="Additional Notes (optional)"
                    v-model="notes"
                  ></v-textarea>
                </v-col>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- SUBMIT -->
      <v-row v-if="requestType && jobSite">
        <v-col xs="12" sm="6">
          <v-btn
            v-if="editMode"
            class="mr-2"
            :disabled="!valid || updating"
            :loading="updating"
            block
            color="primary"
            @click="updateTruckRequest"
            >Update Truck Request
          </v-btn>
          <v-btn
            v-else
            class="mr-2"
            :disabled="!valid || submitting"
            block
            color="primary"
            @click="createTruckRequest"
            >Submit Truck Request
          </v-btn>
          <span class="red--text font-weight-bold" v-if="!valid"
            >* Missing some required fields above.</span
          >
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import JobSelector from "../components/JobSelector";
import JobSelectorAll from "../components/JobSelectorAll";
export default {
  components: {
    JobSelector,
    JobSelectorAll,
  },
  data() {
    return {
      editMode: false,
      loading: true,
      updating: false,
      today: moment().format("YYYY-MM-DD"),
      requestDays: [],
      valid: false,
      submitting: false,
      submitted: false,
      modal: false,
      snack: false,
      snackColor: "",
      snackText: "",
      // form data
      requestType: null,
      numberOfTrucks: 1,
      fullLoadsQty: 1,
      duration: null,
      pickupType: null,
      requestDate: [],
      requestTime: "",
      materialType: [],
      waitTime: null,
      fullLoad: false,
      miniDropoffQty: 0,
      miniPickupQty: 0,
      jobSite: null,
      notes: "",
      miniCount: 0,
      qtyType: "Yards",
      qty: null,
      jobDocId: null,
    };
  },
  computed: {
    ...mapState(["user", "jobSites", "reloadTruckRequest"]),
    pickupTypeOptions() {
      return this.requestType === "Roll Off"
        ? ["Swap", "Live Load", "Pickup", "Drop Off Container"]
        : ["Loose Yards", "Mini Containers"];
    },
  },
  async created() {
    for (let daysBack = 14; daysBack > -1; daysBack--) {
      const day = moment().add(daysBack, "d");
      this.requestDays.push({
        displayDate: day.format("MMM Do (dddd)"),
        requestDate: moment(day.toDate()).format("YYYY-MM-DD"),
      });
    }
    this.requestDays.reverse();

    if (this.$route.params.id) {
      this.editMode = true;
      const id = this.$route.params.id;
      const doc = await fb.db.doc(`truckRequests/${id}`).get();
      const truckRequest = doc.data();

      const {
        requestType,
        jobSite,
        pickupType,
        numberOfTrucks,
        duration,
        requestDate,
        requestTime,
        materialType,
        waitTime,
        fullLoad,
        fullLoadsQty,
        miniDropoffQty,
        miniPickupQty,
        notes,
        miniCount,
        qtyType,
        qty,
      } = truckRequest;

      this.requestType = requestType;
      this.jobSite = jobSite;
      this.pickupType = pickupType;
      this.numberOfTrucks = numberOfTrucks;
      this.duration = duration;
      this.requestDate = requestDate;
      this.requestTime = requestTime;
      this.materialType = materialType;
      this.waitTime = waitTime;
      this.fullLoad = fullLoad;
      this.fullLoadsQty = fullLoadsQty;
      this.miniDropoffQty = miniDropoffQty;
      this.miniPickupQty = miniPickupQty;
      this.notes = notes;
      this.miniCount = miniCount || 0;
      this.qtyType = qtyType;
      this.qty = qty;

      // pre-populate job-selector-all
      this.jobDocId = this.jobSite.id;
    } else if (this.reloadTruckRequest) {
      const {
        requestType,
        jobSite,
        pickupType,
        numberOfTrucks,
        duration,
        requestDate,
        requestTime,
        materialType,
        waitTime,
        fullLoad,
        fullLoadsQty,
        miniDropoffQty,
        miniPickupQty,
        notes,
        miniCount,
        qtyType,
        qty,
      } = this.reloadTruckRequest;
      this.requestType = requestType;
      this.jobSite = jobSite;
      this.pickupType = pickupType;
      this.numberOfTrucks = numberOfTrucks;
      this.duration = duration;
      this.requestDate = [requestDate];
      this.requestTime = requestTime;
      this.materialType = materialType;
      this.waitTime = waitTime;
      this.fullLoad = fullLoad;
      this.fullLoadsQty = fullLoadsQty;
      this.miniDropoffQty = miniDropoffQty;
      this.miniPickupQty = miniPickupQty;
      this.notes = notes;
      this.miniCount = miniCount || 0;
      this.qtyType = qtyType;
      this.qty = qty;
    }
    this.loading = false;
  },
  methods: {
    async updateTruckRequest() {
      try {
        if (!this.jobSite) {
          alert("You must select a job site.");
        }

        if (this.$refs.form.validate()) {
          const obj = {
            jobSite: this.jobSite,
            requestDate: this.requestDate,
            requestDateFormatted: moment(this.requestDate).format("MM/DD/YYYY"),
            duration: this.duration,
            requestType: this.requestType,
            numberOfTrucks: this.numberOfTrucks || 1,
            pickupType: this.pickupType,
            materialType: this.materialType,
            waitTime: this.waitTime,
            qtyType: this.getQtyType(),
            qty: this.qty || 0,
            requestTime: this.requestTime,
            fullLoad: this.fullLoad,
            fullLoadsQty: this.fullLoadsQty,
            miniDropoffQty: this.miniDropoffQty,
            miniPickupQty: this.miniPickupQty,
            notes: this.notes,
          };

          this.updating = true;
          const id = this.$route.params.id;
          await fb.db
            .collection("truckRequests")
            .doc(id)
            .update(obj);
          this.updating = false;
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Success Updating Truck Request!";
        }
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error Updating Truck Request!";
        alert("Error updating Truck Request.");
      }
    },
    async createTruckRequest() {
      try {
        if (!this.jobSite) {
          alert("You must select a job site.");
          return;
        }
        if (this.$refs.form.validate()) {
          this.submitted = true;
          this.submitting = true;
          for (const requestDate of this.requestDate) {
            await fb.db.runTransaction(async (transaction) => {
              // Get the metadata document and increment the count.
              const metaRef = fb.db.doc("metadata/truckRequests");
              const metaData = (await transaction.get(metaRef)).data() || {};

              const number = metaData.count + 1;

              transaction.update(metaRef, {
                count: number,
              });

              // Update the order document
              const requestRef = fb.db
                .collection("truckRequests")
                .doc(number.toString());

              transaction.set(requestRef, {
                jobSite: this.jobSite,
                requestDate: requestDate,
                requestDateFormatted: moment(requestDate).format("MM/DD/YYYY"),
                status: "open",
                duration: this.duration,
                orderedBy: this.user,
                orderDate: fb.timestamp,
                orderNumber: number.toString(),
                requestType: this.requestType,
                numberOfTrucks: this.numberOfTrucks || 1,
                pickupType: this.pickupType,
                materialType: this.materialType,
                waitTime: this.waitTime,
                qtyType: this.getQtyType(),
                qty: this.qty || 0,
                requestTime: this.requestTime,
                fullLoad: this.fullLoad,
                fullLoadsQty: this.fullLoadsQty,
                miniDropoffQty: this.miniDropoffQty,
                miniPickupQty: this.miniPickupQty,
                notes: this.notes,
              });
            });
          }
          this.reset();
          // this.$refs.form.reset();
          this.reset();
          this.submitting = false;
          this.submitted = true;
        }
      } catch (error) {
        this.submitting = false;
        this.submitted = false;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error Submitting Truck Request!";
        alert("Error submitting Truck Request.");
      }
    },
    getQtyType() {
      if (this.requestType == "Mini Pickup/Dropoff") {
        return null;
      }
      if (
        this.pickupType == "Garbage Cans" ||
        this.pickupType == "Mini Containers"
      ) {
        return this.pickupType;
      }
      return "Yards";
    },
    reset() {
      // form reset
      this.requestType = null;
      this.numberOfTrucks = 1;
      this.pickupType = null;
      this.materialType = [];
      this.waitTime = null;
      this.qty = null;
      this.qtyType = null;
      this.requestTime = "";
      this.fullLoad = false;
      this.fullLoadsQty = 1;
      this.miniDropoffQty = 0;
      this.miniPickupQty = 0;
      this.requestDate = [];
      this.notes = "";
      this.duration = null;
    },
    async requestTypeChange() {
      this.requestTypeChangeReset();
      if (this.requestType == "Mini Pickup/Dropoff" && this.jobSite) {
        let miniDoc = await fb.db
          .collection("miniContainers")
          .doc(this.jobSite.id)
          .get();
        this.miniCount = miniDoc.data() ? miniDoc.data().count : 0;
      }
    },
    requestTypeChangeReset() {
      this.pickupType = null;
      this.materialType = [];
      this.waitTime = null;
      this.qty = null;
      this.fullLoad = false;
      this.fullLoadsQty = 1;
      this.miniDropoffQty = 0;
      this.miniPickupQty = 0;
      this.notes = "";
    },
    updateLooseYards() {
      if (this.pickupType == "Loose Yards" && this.fullLoad) {
        if (!this.qty) {
          this.qty = 25;
        }
        const fullLoads = this.fullLoadsQty || 1;
        this.qty = fullLoads * 25;
      }
    },
  },
  beforeDestroy() {
    this.$store.commit("clearReloadedTruckRequest");
  },
};
</script>

<style scoped>
.small-col {
  width: 60px;
}
@media (min-width: 600px) {
  .small-col {
    width: 90px;
  }
}
.med-col {
  width: 100px;
}
</style>
